import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/common/PageHeader";
import { ManualMatcher } from "@/components/products/ManualMatcher";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Products() {
  const navigate = useNavigate();
  return (
    <AppLayout>
      <div className="p-4 md:p-6 lg:p-8 pt-6 space-y-4 max-w-4xl mx-auto">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/tools")} className="shrink-0">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <PageHeader
            title="Banks & Products"
            subtitle="Find the right lender for your client"
          />
        </div>
        
        <ManualMatcher />
      </div>
    </AppLayout>
  );
}
